/**
 * This file was automatically generated by toolspec-generator.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSON file,
 * and run toolspec-generator to regenerate this file.
 */
import { Tool } from '@aws-sdk/client-bedrock-runtime'

export const ChatArtifactsSchema: Tool[] = [
  {
    toolSpec: {
      name: 'add_chat_artifact',
      description:
        'Create a new artifact in this conversation. The artifact is previewed in the chat and opened on its own page; it is not a dashboard in the tree. Declare fetch_mode: snapshot when the code fetches once with absolute time bounds, live when it polls.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            title: {
              type: 'string',
              maxLength: 120,
              description: 'Short display title for the artifact.'
            },
            code: {
              type: 'string',
              description: 'Complete artifact TSX source. Must default-export a React component.'
            },
            fetch_mode: {
              type: 'string',
              enum: ['snapshot', 'live'],
              default: 'snapshot',
              description:
                'Use snapshot when code fetches once with absolute time bounds. Use live only when code polls for current values.'
            }
          },
          required: ['title', 'code', 'fetch_mode']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'edit_chat_artifact',
      description:
        'Overwrite the complete code of an existing artifact in this conversation. Include the full component, not a diff. Supply fetch_mode when the edit changes whether the artifact is a fixed snapshot or a live view.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Artifact UUID.'
            },
            code: {
              type: 'string',
              description: 'Complete replacement TSX source. Must default-export a React component.'
            },
            fetch_mode: {
              type: 'string',
              enum: ['snapshot', 'live'],
              description:
                'Optional replacement fetch mode when the new code changes how data is refreshed.'
            },
            title: {
              type: 'string',
              maxLength: 120,
              description: 'Optional replacement title.'
            }
          },
          required: ['id', 'code']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'grep_chat_artifact',
      description:
        "Search an artifact's stored TSX with a JavaScript regular expression. Without replacement, return matches with line context and do not write. With replacement, apply a global multi-line replacement and persist the complete updated code. Prefer this for small targeted fixes.",
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Artifact UUID.'
            },
            pattern: {
              type: 'string',
              description:
                'JavaScript regular-expression source without surrounding slashes. It is applied globally and in multi-line mode.'
            },
            replacement: {
              type: 'string',
              description:
                'Optional replacement applied to every match. Omit to search without writing; pass an empty string to delete matches.'
            }
          },
          required: ['id', 'pattern']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'read_chat_artifact',
      description:
        'Return the stored code and metadata for one artifact in this conversation. Use before a structural edit or when an artifact ID is provided directly.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: {
              type: 'string',
              description: 'Artifact UUID.'
            }
          },
          required: ['id']
        }
      }
    }
  },
  {
    toolSpec: {
      name: 'list_chat_artifacts',
      description:
        'List visualization artifacts in this conversation as IDs, titles, fetch modes, export state, and update times. Written documents are not included. Code is omitted; call read_chat_artifact when source is needed.',
      inputSchema: {
        json: {
          type: 'object',
          additionalProperties: false,
          properties: {},
          required: []
        }
      }
    }
  }
]

export enum ChatArtifactsToolNames {
  AddChatArtifact = 'add_chat_artifact',
  EditChatArtifact = 'edit_chat_artifact',
  GrepChatArtifact = 'grep_chat_artifact',
  ReadChatArtifact = 'read_chat_artifact',
  ListChatArtifacts = 'list_chat_artifacts'
}
